module.exports = __webpack_public_path__ + "media/packs/images/flags/IR-1b25af69fd0bb319084c3ef1041260b2.png";